import { render } from "./ShipmentsView.vue?vue&type=template&id=438dbde3"
import script from "./ShipmentsView.vue?vue&type=script&lang=js"
export * from "./ShipmentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__